import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./QuoteDisplay.css";
import { Card, CardBody, Button } from "react-bootstrap";

const QuoteDisplay = ({ apiUrl, className }) => {
  const [joke, setJoke] = useState({ setup: "", punchline: "" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showPunchline, setShowPunchline] = useState(false);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    const savedJoke = localStorage.getItem("dailyJoke");
    const savedDate = localStorage.getItem("dailyJokeDate");

    if (savedJoke && savedDate === today) {
      setJoke(JSON.parse(savedJoke));
      setLoading(false);
      return;
    }

    const fetchJoke = async () => {
      try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error("Failed to fetch joke");

        const data = await response.json();
        const newJoke = {
          setup: data.setup,
          punchline: data.punchline,
        };

        setJoke(newJoke);
        localStorage.setItem("dailyJoke", JSON.stringify(newJoke));
        localStorage.setItem("dailyJokeDate", today);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Unable to load joke.");
        setLoading(false);
      }
    };

    fetchJoke();
  }, [apiUrl]);

  if (loading) return <div>Loading joke...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className={className}>
      <Card className="diary-entry-card">
        <CardBody>
          <h4 className="quote-caption">Joke of the Day</h4>

          <div className="card text-center">
            <div className="quote-card-body">

              <p className="card-text"><strong>{joke.setup}</strong></p>

              <p className={`card-text punchline ${showPunchline ? "show" : ""}`}>
                {joke.punchline}
              </p>

              {!showPunchline && (
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => setShowPunchline(true)}
                >
                  Reveal Punchline
                </Button>
              )}

            </div>
          </div>

        </CardBody>
      </Card>
    </div>
  );
};

export default QuoteDisplay;